var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',_vm._b({attrs:{"data":_vm.viewTableData,"columns":_vm.tableColumns,"span-method":_vm.mergeRowMethod}},'vxe-grid',_vm.gridOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }